import { render, staticRenderFns } from "./DeleteCommentConfirm.vue?vue&type=template&id=0d967bd4"
import script from "./DeleteCommentConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteCommentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports